import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import { ApplicationApi, MenuProvider } from "../../../../../../../../../../services/Api/Organization/types";
import MenuExternalPortalGoOrderModal from "./components/MenuExternalPortalGoOrderModal";
import MenuExternalPortalMenuPreview from "./components/MenuExternalPortalMenuPreview";
import MenuExternalPortalOptions from "./components/MenuExternalPortalOptions";

const OrganizationMenuExternalPortalsPage = () => {
	const [providers, setProviders] = useState<MenuProvider[]>();
	const { addFlash } = useFlash();
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const [selectedProvider, setSelectedProvider] = useState<MenuProvider>();
	const [goOrderApps, setGoOrderApps] = useState<ApplicationApi[]>();
	const [showGoOrderModal, setShowGoOrderModal] = useState(false);
	const [selectedGoOrder, setSelectedGoOrder] = useState<ApplicationApi>();
	const [goOrderAppsLoading, setGoOrderAppsLoading] = useState(false);

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		handleChangeTabTitle(`${t("common.word.menu")} | ${t("modules.external_portal.header.title")}`);
		await fetchGoOrderApps();
	};

	const fetchGoOrderApps = async () => {
		setGoOrderAppsLoading(true);
		try {
			const res = await apiOrganization.getApps({
				f: btoa(unescape(encodeURIComponent(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}provider=GOORDER`))),
			});
			if (res.length === 1) {
				setGoOrderApps(res);
				setSelectedGoOrder(res[0]);
				await fetchProviders();
			} else if (res.length > 1) {
				setGoOrderApps(res);
				setShowGoOrderModal(true);
			} else {
				await fetchProviders();
			}
		} catch (err) {
			handleError.alert(err, addFlash);
		}
		setGoOrderAppsLoading(false);
	};

	const fetchProviders = async () => {
		try {
			const providersRes = await apiOrganization.getAppMenuProviders();
			setProviders(providersRes);
			setSelectedProvider(providersRes[0]);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (goOrderAppsLoading) return <LoadingContainer />;

	return (
		<>
			<Header title={t("modules.external_portal.header.title")} />
			<MenuExternalPortalOptions
				providers={providers}
				setSelectedProvider={setSelectedProvider}
				selectedProvider={selectedProvider}
			/>
			{showGoOrderModal && goOrderApps && (
				<MenuExternalPortalGoOrderModal
					show={showGoOrderModal}
					apps={goOrderApps}
					onHide={() => setShowGoOrderModal(false)}
					fetchProviders={fetchProviders}
					setSelectedGoOrder={setSelectedGoOrder}
				/>
			)}
			<MenuExternalPortalMenuPreview selectedGoOrder={selectedGoOrder} provider={selectedProvider} />
		</>
	);
};

export default OrganizationMenuExternalPortalsPage;
